<template>
  <a-modal
    width="760px"
    v-model="isShow"
    centered
    :mask-closable="false"
    title="异常"
  >
    <template slot="footer">
      <a-button class="ant-btn-primary" @click="closeModal">
        关闭
      </a-button>
    </template>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    />
    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </a-modal>
</template>

<script>
import Pagination from '@/components/Pagination/index'
import { findUserLoginAttempts } from '@/api/user'
import { findAgentLoginAttempts } from '@/api/agent'

export default {
  name: 'LoginAttempts',
  components: { Pagination },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    userId: {
      type: Number,
      default: 0
    },
    agentId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      pagination: { total_count: 0 },
      query: { page: 1, per_page: 20 }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '时间',
          width: 180,
          dataIndex: 'created_at'
        },
        {
          title: 'IP',
          width: 160,
          dataIndex: 'ip'
        },
        {
          title: '端',
          width: 100,
          dataIndex: 'client_type'
        },
        {
          title: '场景',
          width: 100,
          dataIndex: 'scene'
        },
        {
          title: '原因',
          dataIndex: 'result'
        }
      ]
    },
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const request = this.agentId
        ? findAgentLoginAttempts(this.agentId, this.query)
        : findUserLoginAttempts(this.userId, this.query)
      this.loading = true
      request.then((res) => {
        if (res.code === 0) {
          this.data = res.data || []
          this.pagination = res.pagination || { total_count: 0 }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    closeModal() {
      this.isShow = false
    }
  }
}
</script>
